import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';
import { SearchEntityResultDto } from './search-entity-result-dto.type';

const SearchResponse = t.type(
  {
    result: nullable(t.record(t.string, SearchEntityResultDto)),
    errorMessage: nullable(t.string),
    hasError: t.boolean,
    sessionId: nullable(t.string),
    requestId: nullable(t.string),
  },
  'SearchRequest',
);

type SearchResponse = t.TypeOf<typeof SearchResponse>;
export { SearchResponse };
